import axios from 'axios'
import router from 'vue-router'

export default {
    state: {
        counter:null,
    },
    mutations: {
        getCounter(state, name){
            state.counter = name
        }

    },
    actions: {
        Counter({commit}, counter){

            axios.post('http://cmsapi.ncu.edu.jm:4775/project/ncuMain/counter/', {
                jobID:counter._id,
                counter:counter.counter +=1

            }).then(function (response) {

               commit('getCounter',response)

            })
                .catch(function (error) {
                    console.log(error);
                });
        }
    },


}
